import OmegaTracker from '@didi/omega-tracker';
import conf from './config';
import env from '@/config/env';
import getCommonParams from '@/lib/request/getCommonParams';
import { getLocalStorage } from '@/utils/localStorage';
import { billEventLogs, billUuidLogs } from '@/omega/const/index';
import LogParams from '@/omega/logParams';
import { is_mobile, is_pad } from '@/utils/os';

const Omega = OmegaTracker.getTracker(conf.omegaConfig);

class LogReport {
  async entry(params) {
    const { eventId, eventLabel, attrs = {} } = params;
    // 公参
    const commonAttrs = await this._getCommonParams(eventId);
    // 业务特定参数
    const businessAttrs = this._getBusinessParams(eventId);
    // 上报
    this._trackEvent(eventId, eventLabel, {
      ...commonAttrs,
      ...businessAttrs,
      ...attrs,
    });
  }
  async _getCommonParams() {
    const { poiId, cityId, lat, lng } = await getCommonParams();
    const commonAttrs = {
      op_system: is_mobile() ? 'phone_web' : is_pad() ? 'pad_web' : 'pc_web',
      poi_id: poiId,
      poi_city_id: cityId,
      poi_latitude: lat,
      poi_longitude: lng,
      uid: getLocalStorage('uid') || -1,
    };
    return commonAttrs;
  }
  _getBusinessParams(eventId) {
    const businessAttrs = {};
    if (billEventLogs.includes(eventId)) {
      // 提单页挽留弹窗event_type统一添加
      businessAttrs.event_type = LogParams.getBillEventType();
    }
    if (billUuidLogs.includes(eventId)) {
      // 提单页埋点添加uuid串联流程
      businessAttrs.uuid = LogParams.getBillUuid();
    }

    return businessAttrs;
  }
  _trackEvent(eventId, eventLabel, attrs) {
    if (env.isDev) {
      console.log('测试环境拦截Omega上报', { eventId, eventLabel, ...attrs });
      return;
    }
    Omega.trackEvent(eventId, eventLabel, attrs);
  }
}

export default new LogReport();
